var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronUpDownMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,4.4140625c0.5351562-0.5332031,1.4648438-0.5332031,2,0l17.2929688,17.2929688l1.4140625-1.4140625L26.4140625,3 C25.125,1.7109375,22.875,1.7109375,21.5859375,3L4.2929688,20.2929688l1.4140625,1.4140625L23,4.4140625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,43.5859375c-0.5351562,0.5332031-1.4648438,0.5332031-2,0L5.7070312,26.2929688l-1.4140625,1.4140625L21.5859375,45 C22.2304688,45.6445312,23.0878906,46,24,46s1.7695312-0.3554688,2.4140625-1l17.2929688-17.2929688l-1.4140625-1.4140625 L25,43.5859375z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDownMedium);
export default __webpack_public_path__ + "static/media/chevron-up-down--medium.72360d17dec8fd8a7e2e4a14e53eb52f.svg";
export { ForwardRef as ReactComponent };